<template>
<v-card :loading="loading" tile class="mb-4">
        <div class="card-title" :class="{ pointer:true }" @click="toggleExpand()">
            {{ taskTitle }}
            <div class="float-end mt-n3">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon color="grey darken-2" class="mt-3 me-4" v-on="on" @click.stop="openTimelineDialog">mdi-timeline-clock-outline</v-icon>
                    </template>
                    <span>{{ $t('TaskTimeline') }}</span>
                </v-tooltip>
                <template v-if="expandable">
                    <v-icon v-if="!expanded" class="float-end mt-3">mdi-chevron-down</v-icon>
                    <v-icon v-else class="float-end mt-3">mdi-chevron-up</v-icon>
                </template>
            </div>
        </div>
        <v-container v-if="expanded" fluid>
            <v-row>
                <LabelData :cols="cols" :label="$t('AssignedTo')" :data="taskInfo.owner" />
                <LabelData :cols="cols" :label="$t('CreatedDate')" :data="taskInfo.createdDate | formatDateTimeGregorian" />
                <LabelData :cols="cols" :label="$t('StartDate')" :data="taskInfo.plannedStartDate | formatDateTimeGregorian" />
                <LabelData :cols="cols" :label="$t('DueDate')" :data="taskInfo.dueDate | formatDateTimeGregorian" />
            </v-row>
        </v-container>
        <v-dialog v-model="timelineDialog" transition="slide-x-transition" content-class="my-custom-dialog">
            <task-timeline v-if="timelineDialog" @close="timelineDialog = false" :taskId="taskId" />
        </v-dialog>
    </v-card>
</template>
<script>
    import TasksService from '@/services/TasksService.js'

    import LabelData from '@/components/controls/LabelData.vue'
    import TaskTimeline from '@/components/app/task/TaskTimeline.vue'

    export default {

        components: {
            LabelData, TaskTimeline
        },

        props: {

            taskId: {
                type: Number,
                default: null
            }

        },

        data() {
            return {
                cols:'3',
                timelineDialog: false,
                loading: false,
                expanded: true,
                expandable: false,
                taskInfo: {
                    title: ''
                }
            }
        },

        computed: {

            taskTitle() {
                return this.$t('TaskTitle') + ': ' + this.taskInfo.title
            }
        },

        created() {
            this.loadTaskInfo()
        },

        methods: {

            openTimelineDialog() {
                this.timelineDialog = true
            },


            toggleExpand() {
                if (this.expandable) {
                    this.expanded = !this.expanded
                }
            },

            loadTaskInfo() {
                this.loading = true

                TasksService.getTaskInfo(this.taskId).then(res => {
                    this.taskInfo = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>
<style>

    .my-custom-dialog {
        width: 33% !important;
        min-height: 100% !important;
        position: absolute;
        left: 0;
        margin: 0;
    }
</style>